export class UserTokens {
    accessToken: string
    refreshToken: string
    returnUrl: string
}
